import { Loader2Icon } from 'lucide-react';
import { useRef } from 'react';

import { useIntersectionObserver } from '@/modules/pagination/useIntersectionObserver';

interface ScrollToBottomIntersectionObserverProps {
  enabled?: boolean;
  onIntersect?: () => void;
  rootMargin?: string;
  isLoading?: boolean;
}

export function ScrollToBottomIntersectionObserver({
  enabled = true,
  onIntersect,
  rootMargin = '240px 0px',
  isLoading = false,
}: ScrollToBottomIntersectionObserverProps) {
  const targetRef = useRef<HTMLDivElement | null>(null);

  useIntersectionObserver({
    target: targetRef,
    onIntersect,
    enabled,
    rootMargin,
  });

  return (
    <div className="flex flex-col items-center gap-4 py-2">
      <div ref={targetRef} className="h-px w-full" />
      {isLoading && (
        <div className="flex justify-center py-2">
          <Loader2Icon className="text-muted-foreground size-5 animate-spin" />
        </div>
      )}
    </div>
  );
}
